import { DateTime } from "luxon";

export function getCalendarMinDate(startDate?: string): Date | undefined {
    if (!startDate) {
        return undefined;
    }

    const minDate = new Date(startDate);
    minDate.setDate(minDate.getDate() - 1);
    return minDate;
}

export function getInitialSelectedDate(
    openedDates: string[],
    startDate: string | undefined,
    maxDate?: Date
): Date | undefined {
    const today = DateTime.local().startOf("day");
    const earliestBookableDay = startDate
        ? DateTime.fromISO(startDate).startOf("day")
        : today;
    const max = maxDate ? DateTime.fromJSDate(maxDate).endOf("day") : undefined;

    if (today < earliestBookableDay) {
        return undefined;
    }

    if (max && today > max) {
        return undefined;
    }

    const todayIsOpen = openedDates.some((isoDate) =>
        DateTime.fromISO(isoDate).hasSame(today, "day")
    );

    if (!todayIsOpen) {
        return undefined;
    }

    return today.toJSDate();
}
